import type { FuseResultMatch } from 'fuse.js';
import { ReactNode } from 'react';

import { highlight } from './fuzzySearchHelper';

export const boldMatchCharacters = (value: string, matches: readonly FuseResultMatch[] = []): ReactNode => {
  if (matches.length) {
    return highlight(value, matches[0].indices);
  }
  return value;
};
